import { ModuleDTO } from 'src/models/dto/ModuleDTO'
import { downloadAsFile } from 'src/services/downloadAsFile'

export const CONTAINER_COLUMN = '__container__'

const PLACEHOLDER_REGEX = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g

const SCORE_PLACEHOLDER_KEY = 'scorePlaceHolder'

export interface PlaceholdersByKind {
    content: string[]
    scoring: string[]
}

export function extractPlaceholders(module: ModuleDTO): PlaceholdersByKind {
    const content = new Set<string>()
    const scoring = new Set<string>()
    const visit = (value: unknown, key?: string) => {
        if (typeof value === 'string') {
            const into = key === SCORE_PLACEHOLDER_KEY ? scoring : content
            const regex = new RegExp(PLACEHOLDER_REGEX)
            let match: RegExpExecArray | null
            while ((match = regex.exec(value)) !== null) {
                into.add(match[1])
            }
        } else if (Array.isArray(value)) {
            value.forEach((element) => visit(element))
        } else if (value && typeof value === 'object') {
            Object.entries(value).forEach(([childKey, child]) => visit(child, childKey))
        }
    }
    visit(module)
    content.delete(CONTAINER_COLUMN)
    scoring.delete(CONTAINER_COLUMN)
    return { content: Array.from(content), scoring: Array.from(scoring) }
}

export function getSpreadsheetColumns(module: ModuleDTO): string[] {
    const { content, scoring } = extractPlaceholders(module)
    return [...Array.from(new Set([...content, ...scoring])), CONTAINER_COLUMN]
}

export function downloadSampleSpreadsheet(columns: string[], moduleName?: string) {
    downloadAsFile(
        new Blob([`${columns.join(',')}\n`], { type: 'text/csv' }),
        `${moduleName ?? 'import'}_sample.csv`
    )
}
